import { Link } from "react-router-dom";
import { BookCallButton } from "@/components/Ctas";
import { Reveal } from "@/components/Reveal";

export default function Placeholder({ title }) {
  return (
    <main
      data-testid="placeholder-page"
      className="flex min-h-[70vh] items-center pt-[72px]"
    >
      <div className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber">
            Coming Soon
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-serif text-4xl font-light tracking-tight text-ink sm:text-5xl">
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-body">
            This page is in the works. In the meantime, the fastest way to get
            answers is a short conversation.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-7">
            <BookCallButton testid="placeholder-cta-book-call" />
            <Link
              data-testid="placeholder-cta-home"
              to="/"
              className="border-b border-ink/30 pb-1 text-sm font-semibold tracking-wide text-ink transition-colors hover:border-amber hover:text-amber"
            >
              Back to Home
            </Link>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
